import {Popover, Select} from "antd";
import React, {memo, useCallback, useMemo} from "react";
import Language from "../../../language";
import {DatamodelRoles} from "./UserManager.types";
import {
  TooltipCategory, TooltipContent,
} from "../../../themes/SharedStyledComponent";

interface Props {
  roles: DatamodelRoles[]
  onUpdate: (newRoles: DatamodelRoles[]) => void
  isDisabled?: boolean
}

const DatamodelRightUpdater = memo<Props>(({
                                  roles,
                                  onUpdate,
                                  isDisabled = false
                               }) => {
  const selectedRoles = useMemo(() => {
    if(roles.includes(DatamodelRoles.DATAMODEL_EXPLORER)){
      return DatamodelRoles.DATAMODEL_EXPLORER
    }
    if(roles.includes(DatamodelRoles.DATAMODEL_VIEWER)){
      return DatamodelRoles.DATAMODEL_VIEWER
    }
    return null
  }, [roles])

  const onChange = useCallback((newRoles: DatamodelRoles | null) => {
    if (newRoles === null) {
      return onUpdate([])
    }
    if(newRoles.includes(DatamodelRoles.DATAMODEL_EXPLORER)){
      return onUpdate([DatamodelRoles.DATAMODEL_EXPLORER])
    } else if(newRoles.includes(DatamodelRoles.DATAMODEL_VIEWER)){
      return onUpdate([DatamodelRoles.DATAMODEL_VIEWER])
    }
    return onUpdate([])
  }, [onUpdate])


  const getPopoverContent = useCallback((value: DatamodelRoles | null) => {
     switch (value) {
       case DatamodelRoles.DATAMODEL_VIEWER:
         return <TooltipContent $width={190}>
            <TooltipCategory>{Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_VIEWER}.title`)}</TooltipCategory>
           {Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_VIEWER}.summary`)}
         </TooltipContent>
       case DatamodelRoles.DATAMODEL_EXPLORER:
         return <TooltipContent $width={190}>
           <TooltipCategory>{Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_EXPLORER}.title`)}</TooltipCategory>
           {Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_EXPLORER}.summary`)}
         </TooltipContent>
       default:
         return undefined
     }
  }, [])

  return <Select style={{minWidth: 125}} popupMatchSelectWidth={true} disabled={isDisabled} value={selectedRoles} onChange={onChange}>
      {
        [{
          value: null,
          label: Language.get("admin.datamodels.rights.noAccess")
        }, {
          value: DatamodelRoles.DATAMODEL_VIEWER,
          label: Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_VIEWER}.title`)
        }, {
          value: DatamodelRoles.DATAMODEL_EXPLORER,
          label: Language.get(`admin.datamodels.rights.${DatamodelRoles.DATAMODEL_EXPLORER}.title`)
        }].map(element => <Select.Option
          key={element.label}
          value={element.value}>
          <Popover
            content={getPopoverContent(element.value)}
            placement={"left"}>
            {element.label}
          </Popover>
        </Select.Option>)
      }
    </Select>
})

export default DatamodelRightUpdater
